module.exports = __webpack_public_path__ + "ci_vendor_newrelic.b2ad3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/ci_vendor_newrelic.svg
// module id = ./src/_asset/sources/assets/images/ci_vendor_newrelic.svg
// module chunks = main